import TSwitch from './switch.vue'
export default TSwitch



// WEBPACK FOOTER //
// ./src/components/switch/index.js